import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import proposalsApi from '../../APIs/proposals';
import { Button, PageHeader, Pagination, Tag } from '../../designComponents';
import Table, { TableDataType } from '../../designComponents/Table';
import Store from '../../store';
import { RootState } from '../../store/selectors';
import theme from '../../theme';
import { PaginationType } from '../../types';
import { humanReadableDate, requestAPI } from '../../utils';
import { ProposalsListingContainerStyled } from '../Proposals/style';

type Props = {};
export type MyParamsType = PaginationType & { search?: string };

const TechnicianProposals = (_props: Props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [search, setSearch] = useState('');
  const proposals = useSelector(
    (state: RootState) => state.technicianAllProposals.data,
  );
  const pagination = useSelector(
    (state: RootState) => state.technicianAllProposals.pagination,
  );
  const getTechnicianProposals = async (myParams: MyParamsType) => {
    try {
      await requestAPI(
        proposalsApi?.getTechnicianAllProposals({
          page: myParams.page,
          limit: myParams.limit,
          ...(myParams?.search ? { search: myParams.search } : []),
        }),
      );
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getTechnicianProposals(pagination);
  }, []);

  const tableDataForEscapeProposal: TableDataType = {
    headings: [
      {
        key: 'createdDate',
        label: 'Date',
      },

      {
        key: 'jobTitle',
        label: 'Job Title',
      },
      {
        key: 'buildingName',
        label: 'Building Name',
      },
      {
        key: 'address',
        label: 'Address',
      },
      {
        key: 'status',
        label: 'Status',
      },
      {
        key: 'actions',
        label: 'Action',
      },
    ],

    body: Array.isArray(proposals)
      ? proposals?.map((proposal) => {
        return {
          id: proposal._id,
          createdDate: humanReadableDate(proposal.createdAt),
          jobTitle: proposal?.job?.jobTitle,
          buildingName: proposal?.job?.building?.buildingName,
          address: proposal?.job?.building?.buildingAddress,
          status: (
              <Tag
                type={
                  proposal?.proposalStatus === 'DECLINE' ||
                  proposal?.proposalStatus === 'REJECT'
                    ? 'danger'
                    : 'success'
                }
              >
                {proposal?.proposalStatus}
              </Tag>
          ),
          actions: (
              <Button
                variant="secondary"
                onClick={() => navigate(proposal._id)}
                style={{
                  backgroundColor: theme.colors.blueLight,
                  border: `1px solid ${theme.colors.blueLight}`,
                }}
              >
                View Proposal
              </Button>
          ),
        };
      })
      : [],
  };
  const handleOnSearchTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearch(value);
    // debouncedFunction({ ...pagination, page: 1, search: value });
  };
  const handlePagination = (updatedParams: PaginationType) => {
    getTechnicianProposals(updatedParams);
    dispatch(
      Store.Actions.update('technicianAllProposals.pagination', updatedParams),
    );
  };

  return (
    <ProposalsListingContainerStyled>
      <PageHeader
        pageTitle="Proposals"
        handleOnSearchTextChange={handleOnSearchTextChange}
        search={search}
      />
      <div className="table-container">
        <Table tableData={tableDataForEscapeProposal} />
      </div>
      <Pagination
        activePage={pagination.page}
        handlePagination={handlePagination}
        limit={pagination.limit}
        totalCount={pagination.totalData || 0}
      />
    </ProposalsListingContainerStyled>
  );
};

export default TechnicianProposals;
